import { addPeer, clearPeers, pushPos, removePeer, setAway, setLink } from '../../3-store/core/peers';
import type { ServerOf } from '../../../shared/protocol';

// 서버 메시지가 일으키는 core의 상태 변경 (메시지 종류 → 처리 함수 표는 1-endpoints/net/server-messages.ts).
// 회의의 몫(자리·발언권)은 2-controllers/meeting/peers.ts가 같은 표에서 이어서 받는다. 여기는 상태(3-store)만 바꾼다.
export function onWelcome(m: ServerOf<'welcome'>) {
  setLink('online', m.id); clearPeers(); (m.players || []).forEach(addPeer);
}
export const onJoined = (m: ServerOf<'joined'>) => addPeer(m.p);
export const onLeft = (m: ServerOf<'left'>) => removePeer(m.id);
export const onPos = (m: ServerOf<'pos'>) => pushPos(m.id, m);
export const onAway = (m: ServerOf<'away'>) => setAway(m.id);
export const onFull = () => setLink('full');
export const onClose = () => { setLink('offline'); clearPeers(); };
